var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { injectable, inject } from '@servicetitan/react-ioc';
import { Status } from './common';
import { NotificationsStore } from './stores/notifications.store';
let NotificationsService = class NotificationsService {
    constructor(store) {
        Object.defineProperty(this, "store", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: store
        });
        Object.defineProperty(this, "initialize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (userId = 0) => {
                await this.store.initialize(userId);
            }
        });
        Object.defineProperty(this, "show", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (options, preventDuplicates) => {
                this.store.add(options, preventDuplicates);
            }
        });
        Object.defineProperty(this, "info", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (options, preventDuplicates) => {
                this.store.add({ ...options, status: Status.Info }, preventDuplicates);
            }
        });
        Object.defineProperty(this, "success", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (options, preventDuplicates) => {
                this.store.add({ ...options, status: Status.Success }, preventDuplicates);
            }
        });
        Object.defineProperty(this, "warning", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (options, preventDuplicates) => {
                this.store.add({ ...options, status: Status.Warning }, preventDuplicates);
            }
        });
        Object.defineProperty(this, "error", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (options, preventDuplicates) => {
                this.store.add({ ...options, status: Status.Error }, preventDuplicates);
            }
        });
    }
};
NotificationsService = __decorate([
    injectable(),
    __param(0, inject(NotificationsStore)),
    __metadata("design:paramtypes", [NotificationsStore])
], NotificationsService);
export { NotificationsService };
//# sourceMappingURL=notifications-service.js.map